import usePagination, { UsePaginationProps } from '@mui/material/usePagination';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Frame, NextPrev, Pages, Page } from '@/components/blocks/UsePagination/parts/main';

type PaginationProps = UsePaginationProps;

export const UsePagination = ({ count = 1, ...props }: PaginationProps) => {
	const { items } = usePagination({
		count,
		...props,
	});

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const prevItem = items.find((item) => item.type === 'previous');
	const nextItem = items.find((item) => item.type === 'next');
	const _items = items.filter((item) => item.type !== 'previous' && item.type !== 'next');

	const multiplePages = count > 1; // Verificar si hay múltiples páginas

	return (
		<Frame isMobile={isMobile}>
			{multiplePages ? (
				<NextPrev disabled={prevItem?.disabled} onClick={prevItem?.onClick}>
					<KeyboardArrowLeftIcon />
					{isMobile ? '' : 'Anterior'}
				</NextPrev>
			) : (
				<Box></Box>
			)}
			<Pages>
				{_items.map(({ page, type, selected, disabled, onClick }, index) => {
					const isEllipsis = type === 'start-ellipsis' || type === 'end-ellipsis';
					const _disabled = disabled || isEllipsis;

					return (
						<li key={index}>
							<Page selected={selected} disabled={_disabled} onClick={onClick}>
								{page || '…'}
							</Page>
						</li>
					);
				})}
			</Pages>
			{multiplePages ? (
				<NextPrev disabled={nextItem?.disabled} onClick={nextItem?.onClick}>
					{isMobile ? '' : 'Siguiente'}
					<KeyboardArrowRightIcon />
				</NextPrev>
			) : (
				<Box></Box>
			)}
		</Frame>
	);
};
